import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  contactsTable: {
    width: "100%",
    display: "flex",
    maxHeight: "60vh",
    borderCollapse: "separate",
    borderSpacing: "10px 30px",

    "& td:last-child": {
      width: "100%"
    }
  },

  contactsContainer: {
    display: "table-row-group",
    overflow: "auto",
    width: "100%",
    border: "none"
  },

  contactsRow: {
    display: "table-row",
    verticalAlign: "center"
  },

  contactsItem: {
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    "&.phoneColumn": {
      width: "35%"
    }
  },

  column: {
    display: "flex",
    alignItems: "center",
    gap: "15px"
  },

  actionsColumn: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    justifyContent: "flex-end"
  },

  pointer: {
    cursor: "pointer"
  },
  personalizedPhoneInput: {
    width: "fit-content !important",
    alignSelf: "center",
    "& > input": {
      border: "none !important",
      boxShadow: "none !important",
      background: "transparent !important",
      "&:hover": {
        border: "none !important"
      }
    },
    "& .flag-dropdown": {
      "& .flag": {
        "& .arrow": {
          display: "none !important"
        }
      }
    }
  }
}));

export default styles;
